export default __webpack_public_path__ + "static/media/office.85942970.jpg";